/**
 * Formats a numeric value as a currency string.
 *
 * @param {number} value - The numeric value to format as a currency string.
 * @param {string} currencyValue - The ISO 4217 currency code to use for formatting the value.
 * If not provided, "GBP" will be used as the default currency code.
 *
 * @returns {string} A string representing the formatted currency value.
 */
export function formatCurrency(
    value: number,
    currencyValue: string,
    maxDecimals: number = 2
) {
    const amount = value || 0;
    return amount.toLocaleString("en-US", {
        style: "currency",
        currency: currencyValue || "GBP",
        minimumFractionDigits: 2,
        maximumFractionDigits: maxDecimals,
    });
}

export default formatCurrency;
